class Dictionary {
    private static readonly words: { [key: string]: string; } = {
        "BaseMaterial" : "Alapanyag",
        "BoardMaterial" : "Bútorlap-anyag",
        "FrontMaterial" : "Frontanyag",
        "BackMaterial" : "Hátfalanyag",
        "ShelfMaterial" : "Polcanyag",
        "DrawerMaterial" : "Fiókanyag"
    }
 
    public static get(word: string): string {
        if(Dictionary.words[word] != null) {
            return Dictionary.words[word];
        }
        return word;
    }

}

export default Dictionary;
